import React from "react";
import './MessageDialog.css';

type MessageDialogProps = {
    ok?: string;
    closeOnAround?: boolean;

    onOk?: () => void;
    onCancel?: () => void;
}

export type MessageDialogHandles = {
    showMessage: (message: string) => Promise<boolean>
}

type resolver = (ok: boolean) => void;

function MAKE_FUNCTION_SETTER<T>(func: T): () => T {
    return () => func
}

const EMPTY_MESSAGE = '';
const EMPTY_RESOLVER = (_: boolean) => {
};

export const MessageDialog = React.forwardRef<MessageDialogHandles, MessageDialogProps>((props, ref) => {
    const close_on_around = !(props.closeOnAround === false);

    const [message, setMessage] = React.useState(EMPTY_MESSAGE);
    const [onClose, setOnClose] = React.useState<resolver>(MAKE_FUNCTION_SETTER(EMPTY_RESOLVER));
    const [nested, setNested] = React.useState<{ message: string, resolve: resolver }[]>([]);

    const dialog_ref = React.useRef<HTMLDialogElement>(null);

    const showModel = (message: string, resolve: resolver) => {
        if (dialog_ref.current?.open) {
            setNested([...nested, {message: message, resolve: resolve}]);
        } else {
            setOnClose(MAKE_FUNCTION_SETTER(resolve));
            setMessage(message);
            dialog_ref.current?.showModal();
        }
    }

    const handleClose = (ok: boolean) => {
        dialog_ref.current?.close();

        onClose(ok);
        ok ? props.onOk?.() : props.onCancel?.();

        const n = nested.shift();
        if (n === undefined) {
            setOnClose(MAKE_FUNCTION_SETTER(EMPTY_RESOLVER));
            setMessage(EMPTY_MESSAGE);
        } else {
            setTimeout(() => showModel(n.message, n.resolve), 0);
        }
    }

    React.useImperativeHandle(ref, () => ({
        showMessage: (message: string) => new Promise<boolean>((resolve) => {
            showModel(message, resolve);
        })
    }));


    return (
        <dialog className="message-dialog" ref={dialog_ref}
                onClick={() => close_on_around && handleClose(false)}
                onCancel={() => handleClose(false)}
        >
            <div onClick={e => e.stopPropagation()}>
                <p className="message-dialog-message-area">{message}</p>
                <p className="message-dialog-button-area">
                    <button className={"message-button-ok"}
                            onClick={() => handleClose(true)}>{props.ok || 'OK'}</button>
                </p>
            </div>
        </dialog>
    );

})
